// Remembers, per tab, the history index of the entry the user logged in from (lobby /
// magic link). Login pushes the destination on top of it, so pressing Back from the first
// protected page lands on this "floor" entry - AppRoutes detects that and steps forward
// again, keeping the user on their protected page instead of going back past the login.
const STORAGE_KEY = 'auth-history-floor';

// React Router's BrowserRouter stores the entry's position as `idx` in history.state.
export const getHistoryIndex = () => {
  const idx = window.history.state?.idx;
  return typeof idx === 'number' ? idx : null;
};

export const markAuthHistoryFloor = () => {
  const idx = getHistoryIndex();
  try {
    if (idx === null) {
      sessionStorage.removeItem(STORAGE_KEY);
    } else {
      sessionStorage.setItem(STORAGE_KEY, String(idx));
    }
  } catch (_) {
    // ignore
  }
};

export const getAuthHistoryFloor = () => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return value === null ? null : Number(value);
  } catch (_) {
    return null;
  }
};

export const clearAuthHistoryFloor = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    // ignore
  }
};
